import { jsx as _jsx } from "react/jsx-runtime";
import MenuItem from '@material-ui/core/MenuItem';
import ActionBarAction from './ActionBarAction';
import useStyles from './ActionBarSelectOption.styles';
export const ActionBarSelectOption = ({ icon, label, selected, disabled, onClick, }) => {
    const classes = useStyles();
    return (_jsx(MenuItem, Object.assign({ disabled: disabled, onClick: onClick, selected: selected, classes: {
            root: classes.root,
            selected: classes.selected,
        } }, { children: _jsx(ActionBarAction, { icon: icon, label: label, disabled: disabled, selected: selected }) })));
};
export default ActionBarSelectOption;
//# sourceMappingURL=ActionBarSelectOption.js.map